import { render, staticRenderFns } from "./MenuRelatoriosEstoque.vue?vue&type=template&id=753a1560&scoped=true&"
import script from "./MenuRelatoriosEstoque.vue?vue&type=script&lang=js&"
export * from "./MenuRelatoriosEstoque.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753a1560",
  null
  
)

export default component.exports